<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.content}}</p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button (click)="yesClick()" color="accent">Yes</button>
  <span></span>
  <button mat-stroked-button (click)="noClick()" color="accent">No</button>
</div>
